import { render, staticRenderFns } from "./PhanHoiList.vue?vue&type=template&id=ba3c1cc6"
import script from "./PhanHoiList.vue?vue&type=script&lang=js"
export * from "./PhanHoiList.vue?vue&type=script&lang=js"
import style0 from "./PhanHoiList.vue?vue&type=style&index=0&id=ba3c1cc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports